import axios from 'axios';
import { ElMessage } from 'element-plus';
import router from '@/router';
import store from '@/store';


const baseURL = '';

// 创建axios实例
const service = axios.create({
  baseURL,
  timeout: 30000
});

///request拦截器
service.interceptors.request.use(req  =>  {
  let userToken = store.state.user.token;
  req.headers['Content-Type'] = 'application/json; charset=UTF-8';
  req.headers.token = userToken;
  return req;
}, err => Promise.reject(err));

//response拦截器
service.interceptors.response.use(res  =>  {
  // 文件流请求不拦截
  if (res.config.responseType === 'blob') return res.data;
  const { status, msg } = res.data;
  if (status === 0 || status === 200) return res.data;
  else if (status === 507) {
    store.commit('user/logout');
    window.location.href = '/login';
  }
  ElMessage.error(msg);
  return Promise.reject(res.data);
}, error => {
  console.log(error);
  ElMessage.error(error);
  return Promise.reject(error);
});

export default service;
